export default {
  map: [{
    name: 'clickstream_interaction',
    version: '3'
  }, {
    name: 'clickstreamInteraction',
    version: '3'
  }, {
    name: 'clickstream_notifications',
    version: '3'
  }, {
    name: 'clickstreamNotifications',
    version: '3'
  }, {
    name: 'clickstream_component_view',
    version: '3'
  }]
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-plat-ui/utils/dist/esm/rio/versions.js
// module id = 5778
// module chunks = 11